import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs';

import { ResidentFacade } from '../../core/services/resident.facade';
import {
  changeEmail,
  changeEmailFail,
  changeEmailSuccess,
  verifyEmail,
  verifyEmailFail,
  verifyEmailSuccess
} from './resident.actions';

@Injectable()
export class ResidentEffects {
  private actions$ = inject(Actions);
  private facade = inject(ResidentFacade);

  verifyEmail$ = createEffect(() =>
    this.actions$.pipe(
      ofType(verifyEmail),
      switchMap(({ token, residentVerificationCode, customerIdent }) =>
        this.facade
          .verifyEmail(token, residentVerificationCode, customerIdent)
          .pipe(
            map(status => verifyEmailSuccess({ status })),
            catchError(error => [verifyEmailFail({ error })])
          )
      )
    )
  );

  changeEmail$ = createEffect(() =>
    this.actions$.pipe(
      ofType(changeEmail),
      switchMap(({ token, customerIdent }) =>
        this.facade.changeEmail(token, customerIdent).pipe(
          map(status => changeEmailSuccess({ status })),
          catchError(error => [changeEmailFail({ error })])
        )
      )
    )
  );
}
